import React, { useCallback, useEffect, useState } from 'react';
import { Button, Input, Popconfirm, Space, Table, Tag, Typography, message } from 'antd';
import { useTranslation } from '../../../../shared/i18n';
import tmService from '../../../services/tmService';
import { fmtTime, ok, toastErr } from './common';

const { Text } = Typography;

/** 沙箱收件人：账号级，添加后发验证邮件，点链接后才可接收沙箱邮件 */
const Recipients = () => {
    const { t } = useTranslation();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [adding, setAdding] = useState(false);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const r = await tmService.listRecipients();
            setRows(Array.isArray(r?.data) ? r.data : []);
        } catch (e) {
            toastErr(e, t('Failed to load'));
        } finally {
            setLoading(false);
        }
    }, [t]);

    useEffect(() => { load(); }, [load]);

    const add = async () => {
        const v = email.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { message.warning(t('Enter a valid email address')); return; }
        setAdding(true);
        try {
            const r = await tmService.createRecipient(v);
            if (ok(r)) { message.success(t('Verification email sent')); setEmail(''); load(); }
        } catch (e) {
            toastErr(e, t('Failed to add'));
        } finally {
            setAdding(false);
        }
    };

    const remove = async (r) => {
        try {
            const res = await tmService.deleteRecipient(r.id);
            if (ok(res)) { message.success(t('Deleted')); load(); }
        } catch (e) {
            toastErr(e, t('Deletion failed'));
        }
    };

    const columns = [
        { title: t('Email'), dataIndex: 'email' },
        { title: t('Status'), dataIndex: 'verified', width: 100, render: (v) => (v ? <Tag color="green">{t('Verified')}</Tag> : <Tag color="orange">{t('Verification pending')}</Tag>) },
        { title: t('Added'), dataIndex: 'created_at', width: 170, render: fmtTime, responsive: ['md'] },
        {
            title: '', key: 'op', width: 80,
            render: (_, r) => (
                <Popconfirm title={t('Delete it?')} onConfirm={() => remove(r)}>
                    <Button type="link" size="small" danger>{t('Delete')}</Button>
                </Popconfirm>
            ),
        },
    ];

    return (
        <div>
            <Space.Compact style={{ maxWidth: 420, width: '100%', marginBottom: 8 }}>
                <Input placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} onPressEnter={add} />
                <Button type="primary" loading={adding} onClick={add}>{t('Add')}</Button>
            </Space.Compact>
            <div style={{ marginBottom: 12 }}>
                <Text type="secondary" style={{ fontSize: 12 }}>{t('The sandbox only sends to verified recipients or to addresses on your verified sending domains')}</Text>
            </div>
            <Table rowKey="id" size="small" loading={loading} dataSource={rows} columns={columns} pagination={false} />
        </div>
    );
};

export default Recipients;
